import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row q-gutter-sm" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("` ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")
  const _component_q_toolbar = _resolveComponent("q-toolbar")
  const _component_q_icon = _resolveComponent("q-icon")
  const _component_q_banner = _resolveComponent("q-banner")
  const _component_q_input = _resolveComponent("q-input")
  const _component_q_tooltip = _resolveComponent("q-tooltip")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_item_section = _resolveComponent("q-item-section")
  const _component_q_item = _resolveComponent("q-item")
  const _component_q_list = _resolveComponent("q-list")
  const _component_q_card_section = _resolveComponent("q-card-section")
  const _component_q_card = _resolveComponent("q-card")
  const _component_UserAttributesLovValueDialog = _resolveComponent("UserAttributesLovValueDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_q_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.usersManagement.attributes')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.attributes && _ctx.userAttributesForm)
          ? (_openBlock(), _createBlock(_component_q_card_section, {
              key: 0,
              class: "row q-gutter-sm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { class: "col-12" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attributes, (attribute) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: attribute.attributeId
                      }, {
                        default: _withCtx(() => [
                          (_ctx.userAttributesForm[attribute.attributeId])
                            ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode("div", _hoisted_1, [
                                    (attribute.required && !_ctx.userAttributesForm[attribute.attributeId][attribute.attributeName])
                                      ? (_openBlock(), _createBlock(_component_q_banner, {
                                          key: 0,
                                          rounded: "",
                                          dense: "",
                                          class: "bg-warning text-center"
                                        }, {
                                          avatar: _withCtx(() => [
                                            _createVNode(_component_q_icon, { name: "warning" })
                                          ]),
                                          default: _withCtx(() => [
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('managers.usersManagement.requiredAttributeInfo', { attributeName: attribute.attributeName })), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_q_input, {
                                      dense: "",
                                      filled: "",
                                      class: "col",
                                      "model-value": _ctx.userAttributesForm[attribute.attributeId][attribute.attributeName],
                                      "onUpdate:modelValue": val => { _ctx.userAttributesForm[attribute.attributeId][attribute.attributeName] = val; _ctx.$emit('formDirty') },
                                      label: attribute.attributeName + (attribute.required ? ' *' : ''),
                                      maxLength: attribute.maxLength
                                    }, {
                                      before: _withCtx(() => [
                                        _createVNode(_component_q_icon, { name: "label" })
                                      ]),
                                      default: _withCtx(() => [
                                        _hoisted_2
                                      ]),
                                      _: 2
                                    }, 1032, ["model-value", "onUpdate:modelValue", "label", "maxLength"]),
                                    (attribute.lovId)
                                      ? (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 1,
                                          round: "",
                                          flat: "",
                                          icon: "edit",
                                          onClick: ($event: any) => (_ctx.openLovValuesDialog(attribute))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_tooltip, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_q_btn, {
                                      round: "",
                                      flat: "",
                                      icon: "backspace",
                                      onClick: ($event: any) => (_ctx.eraseAttribute(attribute))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('common.clear')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_UserAttributesLovValueDialog, {
      attribute: _ctx.selectedAttribute,
      selection: _ctx.initialSelection,
      "dialog-visible": _ctx.lovDialogVisible,
      onSaveLovValues: _ctx.onSaveLovValues,
      onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => {;(_ctx.lovDialogVisible = false), (_ctx.selectedAttribute = null)})
    }, null, 8, ["attribute", "selection", "dialog-visible", "onSaveLovValues"])
  ], 64))
}